export default "__VITE_ASSET__CiEDQ6Pc__"